import React, {useLayoutEffect, useRef, useState} from 'react';
import styles from './styles';
import {oneHalf} from '@xpertdox_js/xdstyle';
import EmailRecipients from './EmailRecipients';
import PatientData from './PatientData';

const EmailRecordDropdown = props => {
  const [contentHeight, setContentHeight] = useState(null);
  const titleRef = useRef();
  const possibleTypes = [
    {key: 'searchPatients', heading: 'Patient Record'},
    {key: 'emailRecords', heading: 'Broadcast Record'}
  ]
  const type = possibleTypes.find(t => props.memo.includes(t.key));

  useLayoutEffect(() => {
    const height = (window.innerHeight > 800 ? window.innerHeight * .5 : window.innerHeight * .7) - titleRef.current.clientHeight - 1 + 'px';
    if (height !== contentHeight) setContentHeight(height);
  })

  return(
    <div style={styles.container} ref={props.measureCallback}>
      <div style={styles.title} ref={titleRef}>
        <div style={oneHalf}>
          <h4 style={styles.titleText}>{type.heading}</h4>
        </div>
        <div style={{...oneHalf, textAlign: 'right'}}>
          {type.key === 'emailRecords' && <span style={styles.date}><b>Date: </b>{props.data.date}</span>}
          {(type.key === 'searchPatients' && props.data.conditions !== '') && <span style={styles.date}><b>Conditions: </b>{props.data.conditions}</span>}
        </div>
      </div>
      <div style={{...styles.content, height: contentHeight}}>
        {
          type.key === 'emailRecords' && <React.Fragment>
            <h5 style={styles.subTitle}>Recipients</h5>
            <EmailRecipients data={props.data.recipients} />
            <h5 style={styles.subTitle}>Subject</h5>
            <span>{props.data.subject}</span>
            <h5 style={styles.subTitle}>Message</h5>
            <p style={styles.message}>{props.data.message}</p>
          </React.Fragment>
        }
        {type.key === 'searchPatients' && <PatientData data={props.data}/>}
      </div>
    </div>
  )
}

export default EmailRecordDropdown;
